import { Text, Tooltip, View } from "../base";
import { Icon } from "../base/Icon";

type OrganizationSettingsTabProps = {
  title: string;
  description?: string;
  /** When provided, renders an info icon next to the title that shows this on hover. */
  tooltip?: string;
  count?: number;
  children: React.ReactNode;
  className?: string;
};

export const OrganizationSettingsTab = ({ title, description, tooltip, count, children, className }: OrganizationSettingsTabProps) => {
  return (
    <View className={`flex flex-col ${className || ""}`}>
      <View className="flex flex-row items-center justify-between mb-3">
        <View className="flex flex-row items-center gap-1.5 leading-none">
          <Text className="text-xs font-medium uppercase tracking-wider text-gray-400 dark:text-gray-500 leading-none">
            {title}
            {count !== undefined && count > 0 ? ` (${count})` : ""}
          </Text>
          {tooltip ? (
            <Tooltip
              content={tooltip}
              placement="bottom"
            >
              <span className="inline-flex items-center text-gray-400 dark:text-gray-500 cursor-help">
                <Icon
                  name="info"
                  size={12}
                  className="shrink-0"
                />
              </span>
            </Tooltip>
          ) : null}
        </View>
      </View>
      {children}
    </View>
  );
};
